import $ from 'jquery';
import BaseModule from './BaseModule';

export default class Accordion extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'Accordion');
    this.register();
  }

  register() {
    $(this.el).on('click', '.accordion-title', function () {
      const thisContent = $(this).next('.accordion-content');
      const parent = $(this).parent();

      if (!parent.hasClass('active')) {
        thisContent.slideDown(300, function () {
          parent.addClass('active');
        });

        parent.siblings().find('.accordion-content').slideUp(300, function () {
          parent.siblings().removeClass('active');
        });
      } else {
        thisContent.slideUp(300, function () {
          parent.removeClass('active');
        });
      }
    });
  }
}
